<template>
    <div class="jackpot-block">
        <p class="jackpot-block__text">
            {{ "components.common.jackpots.jackpot-fake.jackpot" | translate }} 
            <span class="jackpot-block__delimiter"></span> 
            <span class="jackpot-block__currency">{{ (startJackpotValue + jackpotValue) | currency(defaultCurrency)}}</span>
        </p>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'jackpot-fake',
    data() {
        return {
            startDateJackpot: 1691528400000, // ms new Date('2023/08/09').valueOf(),
            startJackpotValue: 5000000, // 50 000.00
            jackpotValue: null,
            idTimeout: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get() || {};
        },
        defaultCurrency(){
            return this.client.general && this.client.general.defaultCurrency;
        }
    },
    methods: {
        async jackpotValueIncrease() {
            const timeMsIncrease = new Date().valueOf() - this.startDateJackpot;
            const seconds = Math.floor(timeMsIncrease / 1000);
            const intervalIncrease = Math.floor(seconds / 5);
            const intervalDivider = Math.floor(intervalIncrease / 4);

            switch (intervalIncrease % 4) {
                case 0:
                    this.jackpotValue = (intervalDivider * 3) + (intervalDivider * 2) + (intervalDivider * 4) + (intervalDivider * 1);
                    break;
                case 1:
                    this.jackpotValue = ((intervalDivider + 1) * 3) + (intervalDivider * 2) + (intervalDivider * 4) + (intervalDivider * 1);
                    break;
                case 2:
                    this.jackpotValue = ((intervalDivider + 1) * 3) + ((intervalDivider + 1) * 2) + (intervalDivider * 4) + (intervalDivider * 1);
                    break;
                case 3:
                    this.jackpotValue = ((intervalDivider + 1) * 3) + ((intervalDivider + 1) * 2) + ((intervalDivider + 1) * 4) + (intervalDivider * 1);
                    break;
            }
        },
        async timer() {
            await this.jackpotValueIncrease();
            this.idTimeout = setTimeout(this.timer, 5000);
        }
    },

    async mounted() {
        await this.timer();
    },

    beforeDestroy() {
        if (this.idTimeout) {
            clearTimeout(this.idTimeout);
        }
    }
}
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/jackpots/jackpot-fake/jackpot-fake.vue